var plan_id = '';
var total_outlets = '';
$(document).ready(function () {
    /*$( ".price-col" ).hover(
      function() {
        $(this).addClass('selected');
      }, function() {
        $(this).removeClass('selected');
      }
    );*/

    $('.cmn-custom-select2').each(function (i, ele) {
        $(ele).select2({
            width: '100%',
            dropdownParent: $(ele).closest('.cmn-select2-wrapper'),
            dropdownAutoWidth: 'true',
            placeholder: function () {
                $(this).data('placeholder');
            }
        });
    });

    $('body').on('change', '.total_outlets', function () {
        $(this).closest('.price-col').find('.purchase_plan').attr('data-outlets', $(this).val());
        $(this).closest('.price-col').find('price').html($(this).val() * $(this).attr('data-price'));
    });

    $('body').on('click', '.purchase_plan', function () {
        plan_id = $(this).attr('data-plan');
        total_outlets = $(this).attr('data-outlets');
        $('#registerMerchantModal').toggleClass('is-visible');
        $('body').toggleClass('is-modal');
    });

    /*$('#terms_conditions').scroll(function () {
        if ($(this).scrollTop() + $(this).innerHeight() +2 >= $(this)[0].scrollHeight) {
            $('.reg_btn').removeAttr('disabled');
        }
    });*/

    $('body').on('click', '.close_modal', function (e) {
        e.preventDefault();
        $(this).closest('.modal').toggleClass('is-visible');
        if ($(this).closest('.modal').find('form').length) {
            $(this).closest('.modal').find('form')[0].reset();
            //$('.reg_btn').prop('disabled', true);
            $('#country_id, #state_id, #city_id').val('').trigger('change.select2');
            $(this).closest('.modal').find('form').find('input, select, textarea').each(function (i, ele) {
                if ($(ele).closest('.form-group').hasClass('invalid')) {
                    $(ele).closest('.form-group').removeClass('invalid');
                    $(ele).removeClass('validate-message');
                    $(ele).closest('.form-group').find('.validate-message').remove();
                    $(ele).closest('.form-group').find('.js-error').remove();
                }
            });
        }
        $('body').toggleClass('is-modal');
    });

    $('#country_id').on('change', function () {
        getStatesList();
    });

    $('#state_id').on('change', function () {
        getCitiesList();
    });

    $('#registerForm').validate({
        rules: {
            name: {
                required: true,
                maxlength: 50
            },
            email: {
                required: true,
                email: true,
                validate_email: true,
                maxlength: 50
            },
            phone_code: {
                required: true
            },
            phone_number: {
                required: true,
                validate_phone: true,
            },
            brand_name: {
                required: true,
                maxlength: 50
            },
            gst_number: {
                required: true,
                maxlength: 15
            },
            address: {
                required: true,
                maxlength: 100
            },
            country_id: {
                required: true
            },
            state_id: {
                required: true
            },
            city_id: {
                required: true
            },
            zip_code: {
                required: true,
                maxlength: 10
            },
            password: {
                required: true,
                pwcheck: true
            },
            confirm_password: {
                required: true,
                equalTo: "#password"
            },
            terms_conditions: {
                required: true
            }
        },
        messages: {
            name: {
                required: "Please enter the Name"
            },
            email: {
                required: "Please enter the Email",
                email: "Please enter a valid Email"
            },
            phone_code: {
                required: "Please select the Phone Code"
            },
            phone_number: {
                required: "Please enter the Phone Number",
            },
            brand_name: {
                required: 'Please enter the Brand Name',
            },
            gst_number: {
                required: 'Please enter the GST Number',
                maxlength: "Please do not enter more than 15 characters"
            },
            city_id: {
                required: 'Please select the City',
            },
            state_id: {
                required: 'Please select the State',
            },
            country_id: {
                required: 'Please select the Country',
            },
            zip_code: {
                required: "Please enter the Zipcode",
                maxlength: "Please do not enter more than 10 characters"
            },
            password: {
                required: "Please enter the Password"
            },
            confirm_password: {
                required: 'Please enter the Confirm Password',
                equalTo: 'Password and Confirm password must be same',
            },
            terms_conditions: {
                required: "Please accept our Terms and Conditions by clicking this"
            }
        },
        errorElement: 'div',
        errorClass: 'validate-message',
        errorPlacement: function (error, element) {
            errorMsgPlacement(error, element);
        },
        invalidHandler: function (event, validator) {
            invalidHandlerSubmit();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').addClass('invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('invalid');
        },
        submitHandler: function (form) {
            $.ajax({
                url: appConfig.api_url + 'signup',
                type: 'POST',
                dataType: 'json',
                data: $(form).serialize(),
                beforeSend: function () {
                    showLoader();
                },
                success: function (data) {
                    //hideLoader();
                    $(form)[0].reset();
                    submitPayment(data.data.uuid, plan_id, total_outlets);
                },
                error: function (xhr) {
                    hideLoader();
                    showErrorAlertFromException(xhr, form);
                }
            });
            return false;
        }
    });
});

function submitPayment(merchant_id, plan_id, total_outlets) {
    $.ajax({
        url: appConfig.api_url + "subscription/pay",
        type: "POST",
        data: { merchant_id: merchant_id, plan_id: plan_id, total_outlets: total_outlets },
        dataType: 'json',
        beforeSubmit: function (arr, $form, options) {
            return true;
        },
        beforeSend: function () {
            showLoader();
        },
        success: function (response) {
            if (response.meta.status) {
                window.location.href = response.data.payment_url;
            }
        },
        error: function (xhr) {
            hideLoader();
            showErrorAlertFromException(xhr)
        }
    });
}


function getStatesList() {
    let country_id = $('#country_id').val();
    let statesData = '';
    $.ajax({
        url: appConfig.api_url + "states/list/" + country_id,
        type: 'GET',
        dataType: 'json',
        beforeSend: function () {
            showLoader();
        },
        success: function (data) {
            hideLoader();
            $('#state_id').html('');
            if (data.data.length > 0) {
                statesData += "<option value=''>Select State</option>";
                $.each(data.data, function (index, val) {

                    statesData += '<option value="' + val.id + '">' + val.name + '</option>';
                });
                $('#state_id').html(statesData);
            }
        },
        error: function (xhr) {
            hideLoader();
            showErrorAlertFromException(xhr)
        }
    });
}

function getCitiesList() {
    let state_id = $('#state_id').val();
    let citiesData = '';
    $.ajax({
        url: appConfig.api_url + "cities/list/" + state_id,
        type: 'GET',
        dataType: 'json',
        beforeSend: function () {
            showLoader();
        },
        success: function (data) {
            hideLoader();
            $('#city_id').html('');
            if (data.data.length > 0) {
                citiesData += "<option value=''>Select City</option>";
                $.each(data.data, function (index, val) {
                    citiesData += '<option value="' + val.id + '">' + val.name + '</option>';
                });
                $('#city_id').html(citiesData);
            }
        },
        error: function (xhr) {
            hideLoader();
            showErrorAlertFromException(xhr)
        }
    });
}